/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React from 'react';
import FormControl from 'react-bootstrap/es/FormControl';
import cx from 'classnames';

var RadioButton = function RadioButton(_ref) {
  var name = _ref.name,
      value = _ref.value,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      checked = _ref.checked,
      label = _ref.label,
      addon = _ref.addon,
      labelClassName = _ref.labelClassName,
      labelContentsClassName = _ref.labelContentsClassName,
      inputClassName = _ref.inputClassName;
  return React.createElement("div", {
    className: "RadioButton-wrapper"
  }, React.createElement("label", {
    className: cx('RadioButton-label', labelClassName)
  }, React.createElement("span", {
    className: cx(labelContentsClassName, {
      'Opm-disabled': disabled
    })
  }, React.createElement(FormControl, {
    type: "radio",
    bsClass: "",
    className: cx('RadioButton-radio', inputClassName),
    name: name,
    value: value,
    onChange: onChange,
    checked: checked,
    disabled: disabled
  }), label), addon));
};

RadioButton.displayName = 'RadioButton';
RadioButton.propTypes = {
  addon: PropTypes.any,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  inputClassName: PropTypes.string,
  label: PropTypes.any,
  labelClassName: PropTypes.string,
  labelContentsClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};
export default RadioButton;